import React from 'react'
import GlobalProvider from './Contexts/GlobalProvider'
import type { RetorikMainComponentProps } from '../models/retorikTypes'
import ShadowRoot from './Common/ShadowRoot'
import RetorikConfigHandler from './Common/RetorikConfigHandler'
import { ContainerParent } from '../models/enums'

const RetorikNews = (props: RetorikMainComponentProps): JSX.Element => {
  // --------- /!\ -----------
  // Ne mettre ici que de la logique spécifique au retorikNews
  // Ce qui est commun avec RetorikWidget ou autres doit aller dans RetorikComposer ou ContextProvider
  // -------------------------

  return (
    <GlobalProvider instanceId={props.instanceId}>
      <ShadowRoot>
        <RetorikConfigHandler {...{ parent: ContainerParent.news, ...props }} />
      </ShadowRoot>
    </GlobalProvider>
  )
}

export default RetorikNews
